import API from '@/api/api'

export default {
  // eslint-disable-next-line
  GET_SUBMISSIONS ({ }, data) {
    return API.GET.submissions.all(data)
  },
  GET_LEADERBOARD ({ }, data) {
    return API.GET.submissions.leaderboard(data)
  },
  // eslint-disable-next-line
  GET_JUDGE_SUBMISSIONS ({ }, data) {
    return API.GET.submissions.judge(data)
  },
  // eslint-disable-next-line
  SAVE_SUBMISSION_GRADE ({ }, data) {
    return API.PUT.submissions.saveGrades(data)
  },
  // eslint-disable-next-line
  SAVE_SUBMISSION_VIDEO ({ }, data) {
    return API.PUT.submissions.saveVideo(data)
  },
  // eslint-disable-next-line
  DELETE_SUBMISSIONS ({ }, data) {
    return API.DELETE.submissions(data)
  },
  saveSubmissions ({ rootState, commit}, data) {
    let currentUser = rootState.users.currentUser

    data.map(submission => {
      if (typeof submission.scores !== 'undefined') {
        if (submission.scores.length > 0) {
          //  Get total avg score
          let finalScore = []

          submission.scores.map(grading => {
            finalScore.push(grading.score)
          })

          finalScore = Math.round(finalScore.reduce((a, b )=> { return a + b }) / finalScore.length * 100) / 100
          submission['finalScore'] = finalScore

          //  Determine if current user is judge and has graded submission
          if (currentUser.role === 'judge') {
            const hasGraded = submission.scores.findIndex(item => {
              return item.judge === currentUser._id
            }) >= 0
            submission['hasGraded'] = hasGraded
          }

          //  Determine if current user is submission owner
          if (currentUser._id === submission.userId) {
            submission['isOwner'] = true
          } else {
            submission['isOwner'] = false
          }
        } else {
          submission['finalScore'] = false
        }
      }
    })

    //  Sort by descending final score
    data.sort((a, b) => {
      return b.finalScore - a.finalScore
    })

    commit('saveSubmissions', data)
  }
}
